import ProductCheckout from "../components/ProductCheckout";
import EvolutivoCard from "../components/EvolutivoCard";

const THEME = {
  primary: "#ff4500",
  primaryHover: "#ff5722",
  bg: "#050505",
};

export default function Evolutivos() {
  return (
    <ProductCheckout
      category="evolutivos"
      theme={THEME}
      title={
        <>
          TOKENS Y CAJAS <span style={{ color: THEME.primary }}>EVOLUTIVAS</span>
        </>
      }
      subtitle="Sumá tokens, cajas evolutivas y tarjetas de Free Fire a tu cuenta. Tokens y cajas: transferí al alias, adjuntá el comprobante y envianos el pedido por WhatsApp (mínimo 50 tokens o 10 cajas). Tarjetas: pagás por CVU y se acreditan solas."
      bulletTag="EVOLUTIVOS · TARJETAS · FREE FIRE"
      ProductCard={EvolutivoCard}
      extraCategory="tarjetas"
    />
  );
}
